import React from "react";
import { useTranslation } from "react-i18next";
import { BsDatabaseDown } from "react-icons/bs";
import { useUseCases } from "@/context/UseCasesProvider";
import { useTemplateLoader } from "@/hooks/useTemplateLoader";
import DatabaseSpecificsDefault from "@/components/specifics/DatabaseSpecifics_Default";

function Database() {
  const { t } = useTranslation();
  const settingsInterface = useUseCases();
  const organizationName = settingsInterface?.settings?.organization?.name || 'Default';

  const DatabaseSpecificsTemplate = useTemplateLoader(
    'DatabaseSpecifics',
    organizationName,
    DatabaseSpecificsDefault
  );

  return (
    <>
      <div className="w-full text-vistagrey my-6 inline-flex">
        <div>
          <div className="text-vistagrey text-xl">
            <BsDatabaseDown className="fill-vistagreen inline-block text-4xl mr-2" />
            {t("database")}
          </div>
          <div className="text-sm pl-11 -mt-2">{t("import_export")}</div>
        </div>
      </div>

      <div className="mb-6">
        <DatabaseSpecificsTemplate />
      </div>
    </>
  );
}

export default Database;
